import { ReactNode } from 'react';
import { OpenFeatureProvider } from '@openfeature/react-sdk';

interface FeatureFlagProviderProps {
  children: ReactNode;
}

/**
 * Provider component that wraps the app with OpenFeatureProvider
 * Note: Datadog Feature Flags should be initialized in main.tsx before this component renders
 * The global provider set via OpenFeature.setProvider() will be used automatically
 * suspendUntilReady ensures components wait for the provider to be ready before evaluating flags
 */
export const FeatureFlagProvider: React.FC<FeatureFlagProviderProps> = ({
  children,
}) => {
  // OpenFeatureProvider will use the provider set globally via OpenFeature.setProvider()
  // suspendUntilReady ensures components wait for the provider to be ready before evaluating flags
  // This prevents returning default values before flags are fetched from Datadog
  return (
    <OpenFeatureProvider suspendUntilReady>{children}</OpenFeatureProvider>
  );
};
